import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { GdoPaymentContainerComponent } from './gdo-payment-container/gdo-payment-container.component';
import { GdoPaymentComponentsComponent } from './gdo-payment-components/gdo-payment-components.component';
import { GdoBraintreeIntegrationComponent } from './gdo-payment-components/gdo-braintree-integration/gdo-braintree-integration.component';
import { GdoPaymentOptionsComponent } from './gdo-payment-components/gdo-payment-options/gdo-payment-options.component';
import { GdoAccountBillingHistoryComponent } from './gdo-payment-components/gdo-account-billing-history/gdo-account-billing-history.component';
import { GdoAddNewPaymentOptionsComponent } from './gdo-payment-components/gdo-payment-options/gdo-add-new-payment-options/gdo-add-new-payment-options.component';

const routes: Routes = [
  {
    path: '',
    component: GdoPaymentContainerComponent,
    children: [
      {
        path: '',
        /*
        default! 
        URL: HOST/billing
        */
        component: GdoPaymentComponentsComponent,
        children:[
          {
            path:'',
            component:GdoPaymentOptionsComponent
          },
          {
            path:'addNewPaymentOption',
            component:GdoAddNewPaymentOptionsComponent
          },
          {
            path:'billingHistory',
            component:GdoAccountBillingHistoryComponent
          },
          {
            path: 'braintreeUiDropIn',
            /*
            URL: billing/braintreeUiDropIn
            */
            component: GdoBraintreeIntegrationComponent,
          },
        ]
      },
    ],
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class GdoPaymentRoutingModule {}
